const pisSegments = {
  bindings: {},
  templateUrl: '/modules/pis-tool/segments/segments.html',
  controller: 'PISSegmentsController',
};

angular
  .module('segments.module', [])
  .component('pisSegments', pisSegments)
  .config(function($stateProvider) {
    $stateProvider.state('pis.segments', {
      url: '/segments',
      views: {
        'pisview@pis': 'pisSegments',
      },
    });
  });
